import React, { FC } from 'react';
import './ContactForm.css';
import {
	FaUserTag,
	FaUser,
	FaBriefcase,
	FaCalendarAlt,
	FaCity,
	FaPhone,
	FaEnvelope,
	InputField,
	SelectField,
	TextAreaField,
	CheckBoxField,
	RequiredNote,
	DomainFormProps,
} from '@/Shared';


/**
 * =====================================================
 * Component: ContactForm
 * =====================================================
 *
 *
 * Domain-specific form UI for Contact.
 * Mounted inside GenericDomainForm.
 *
 * Responsibilities:
 * - Render contact fields
 * - Use data from formVM (options, values)
 *
 * No permissions, no loading, no orchestration logic here.
 *
 * Author: Samano CASTRE
 * Date: February 15, 2026
 */
const ContactForm: FC<DomainFormProps> = ({
	domainFormHook,
	formRef
}) => {

	const { entityFormVM } = domainFormHook;

	/**
	 * =====================================================
	 * Main Form Rendering
	 * =====================================================
	 *
	 * Fieldsets organize the form into logical sections for clarity.
	 */
	return (
		<div className="fieldset-wrapper">
			<fieldset>
				<legend>Civilité</legend>
				<InputField
					label='Nom'
					icon={<FaUser />}
					name='person.lastname'
					placeholder='Saisir le nom du contact'
					autoComplete='name'
					required
				/>

				<InputField
					label='Prénom'
					icon={<FaUser />}
					name='person.firstname'
					placeholder='Saisir le prénom du contact'
					autoComplete='given-name'
				/>

				<SelectField
					label='Civilité'
					icon={<FaUser />}
					name='person.civility'
					placeholder='Choisir une civilité'
					options={entityFormVM.civilityOptions}
					scrollParent={formRef.current}
					required
				/>

				<SelectField
					label='Type'
					icon={<FaUserTag />}
					name='contactType'
					placeholder='Choisir un type de contact'
					options={entityFormVM.contactTypeOptions}
					scrollParent={formRef.current}
					required
				/>

				<InputField
					label='Date de naissance'
					icon={<FaCalendarAlt />}
					name='person.birthDate'
					type='date'
					autoComplete='bday' />
				<RequiredNote />
			</fieldset>
			<fieldset>
				<legend>Localisation</legend>
				<TextAreaField
					name="person.address"
					label='Adresse'
					placeholder={"Saisir l'adresse du contact"}
				/>
				<InputField
					label='Ville'
					icon={<FaCity />}
					name='person.city'
					placeholder='Saisir la ville du contact'
					autoComplete='address-level2'
				/>

				<InputField
					label='Pays'
					icon={<FaCity />}
					name='person.country'
					placeholder='Saisir le pays du contact'
					autoComplete='on' />
			</fieldset>
			<fieldset>
				<legend>Coordonnées</legend>
				<InputField
					label='Profession'
					icon={<FaBriefcase />}
					name='person.profession'
					placeholder='Saisir la profession du contact'
					autoComplete='on' />

				<InputField
					label='Téléphone 1'
					icon={<FaPhone />}
					name='person.phone1'
					placeholder='Saisir le téléphone du contact'
					type='tel'
					autoComplete='tel' />

				<InputField
					label='Téléphone 2'
					icon={<FaPhone />}
					name='person.phone2'
					placeholder='Saisir le téléphone du contact'
					type='tel'
					autoComplete='tel' />

				<InputField
					label='Email'
					icon={<FaEnvelope />}
					name='person.email'
					placeholder="Saisir l'e-mail du contact"
					type='email'
					autoComplete='email' />
			</fieldset>
			<fieldset>
				<legend>Autres</legend>
				<TextAreaField
					name="note"
					label='Note'
					placeholder={"Ecrire quelque chose..."}
				/>

				<InputField
					label='Origine'
					icon={<FaCity />}
					name='origin'
					placeholder="Saisir l'origine du contact"
					autoComplete='on' />

				<SelectField
					label='Suivi par'
					icon={<FaUser />}
					name='agentId'
					options={entityFormVM.referentOptions}
					scrollParent={formRef.current}
					placeholder="Choisir un référent"
				/>

				<CheckBoxField label="Statut (Clôturé)" name="isClosed" />
			</fieldset>
		</div>
	);
}
export default ContactForm;